import { TifCarriageIcon } from '@/components/icons/tif/TifCarriageIcon';
import { tenantSelector } from '@/features/configuration/configurationSelector';
import { useSelector } from '@/store/utils';
import { Icons, type IconProps } from '@packages/webshop-design-system';

/** Carriage pictogram; uses TIF branding for `tifrance` (BR-57773). */
export const CarriagePictogram = (props: IconProps) => {
  const { value: tenant } = useSelector(tenantSelector);
  const Icon = tenant === 'tifrance' ? TifCarriageIcon : Icons.carriage;

  return <Icon {...props} />;
};
